// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__fOhwR"};